function initFAQ() {
  const faqButtons = document.querySelectorAll('[aria-controls^="faq-"]');

  faqButtons.forEach((button, index) => {
    button.addEventListener('click', () => {
      const isExpanded = button.getAttribute('aria-expanded') === 'true';
      const content = document.getElementById(`faq-${index}`);
      const plusIcon = button.querySelector('svg:not(.hidden)');
      const minusIcon = button.querySelector('svg.hidden');

      // Toggle aria-expanded
      button.setAttribute('aria-expanded', !isExpanded);

      // Toggle content visibility
      if (!isExpanded) {
        console.log('expanding');
        content.classList.toggle('hidden');
        content.style.maxHeight = `${content.scrollHeight}px`;
        content.style.opacity = '1';
      } else {
        console.log('collapsing');
        content.classList.toggle('hidden');
        content.style.maxHeight = '0';
        content.style.opacity = '0';
      }

      // Toggle icons
      plusIcon.classList.toggle('hidden');
      minusIcon.classList.toggle('hidden');
    });
  });
}

// Handle product form submission to skip cart and go directly to checkout
function initProductForm() {
  const productForm = document.getElementById('product-form');
  if (productForm) {
    productForm.addEventListener('submit', function (e) {
      e.preventDefault();

      // Get the submit button and add loading state
      const submitButton = this.querySelector('.btn-cta');
      if (submitButton) {
        submitButton.classList.add('loading');
      }

      // Get form data
      const formData = new FormData(this);

      // Always clear the cart first to ensure only one product
      fetch('/cart/clear.js', {
        method: 'POST',
      })
        .then(() => {
          // After clearing, add the new product to cart
          return fetch('/cart/add.js', {
            method: 'POST',
            body: formData,
          });
        })
        .then((response) => response.json())
        .then((data) => {
          if (data.status === 422) {
            // Handle errors
            console.error('Add to cart error:', data);
            // Remove loading state on error
            if (submitButton) {
              submitButton.classList.remove('loading');
            }
          } else {
            // Redirect to checkout
            window.location.href = '/checkout';
          }
        })
        .catch((error) => {
          console.error('Error with cart operation:', error);
          // Remove loading state on error
          if (submitButton) {
            submitButton.classList.remove('loading');
          }
        });
    });
  }
}

// Initialize loading functionality for .btn-cta buttons
function initButtonLoading() {
  // Handle automatic loading for forms with .btn-cta submit buttons
  const formsWithCTAButtons = document.querySelectorAll('form:has(.btn-cta[type="submit"])');

  formsWithCTAButtons.forEach((form) => {
    form.addEventListener('submit', function (e) {
      const submitButton = this.querySelector('.btn-cta[type="submit"]');
      if (submitButton) {
        submitButton.classList.add('loading');
      }
    });
  });

  // Handle manual loading for buttons with data-loading attribute
  const manualLoadingButtons = document.querySelectorAll('.btn-cta[data-loading]');

  manualLoadingButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      // Add loading state
      this.classList.add('loading');

      // Simulate async operation (replace with your actual async logic)
      const loadingDuration = parseInt(this.getAttribute('data-loading')) || 2000;

      setTimeout(() => {
        this.classList.remove('loading');
      }, loadingDuration);
    });
  });

  // Handle loading for buttons with data-loading-url attribute (for navigation)
  const navigationButtons = document.querySelectorAll('.btn-cta[data-loading-url]');

  navigationButtons.forEach((button) => {
    button.addEventListener('click', function (e) {
      const url = this.getAttribute('data-loading-url');
      if (url) {
        e.preventDefault();
        this.classList.add('loading');

        // Navigate after a brief delay to show loading state
        setTimeout(() => {
          window.location.href = url;
        }, 500);
      }
    });
  });
}

// Redirect from specific pages to homepage
function redirectFromSpecificPages() {
  const currentPath = window.location.pathname;

  // Redirect from cart page
  if (currentPath === '/cart') {
    window.location.href = '/';
  }

  // Redirect from all products collection page
  if (currentPath === '/collections/all') {
    window.location.href = '/';
  }
}

// Initialize all components when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  initFAQ();
  initProductForm();
  initButtonLoading();
  redirectFromSpecificPages();
});
